<template>
  <v-card
    :loading="loading"
    class="my-4"
  >
    <v-card-title class="mt-3">
      Guides
      <v-spacer />
      <v-select
        v-model="productId"
        class="min-width mr-2"
        :items="products"
        hide-details
        clearable
        outlined
        item-value="id"
        item-text="name"
        label="Filter Product"
        dense
      />
      <v-btn
        color="primary"
        @click="add"
      >
        Add
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-data-table
        :items="guidesToShow"
        :headers="headers"
        :items-per-page="1000"
        :sort-by="['isDefault']"
        :sort-desc="[true]"
        class="row-pointer"
        mobile-breakpoint="0"
        @click:row="rowClick"
      >
        <template #[`item.isDefault`]="{ item }">
          <v-icon
            v-if="item.isDefault"
            color="success"
          >
            mdi-check
          </v-icon>
        </template>
        <template #[`item.actions`]>
          <v-icon>more_vert</v-icon>
        </template>
      </v-data-table>
    </v-card-text>
    <GuidesEdit @save="loadData" />
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import GuidesEdit from '@/components/guides/Edit';
import { sortBy, uniqBy } from 'lodash';
export default {
  name: 'ListGuides',
  components: { GuidesEdit },
  data() {
    return {
      loading: false,
      productId: null
    };
  },

  computed: {
    headers() {
      const list = [
        { text: 'Name', value: 'name', show: true },
        { text: 'Description', value: 'description', show: true },
        { text: 'Product', value: 'coreProduct.name', show: true },
        { text: 'Default?', value: 'isDefault', show: true },
        { text: '', value: 'actions', show: true }
      ];

      return list.filter((x) => x.show);
    },
    products() {
      return sortBy(
        uniqBy(
          this.guides.map((x) => x.coreProduct),
          'id'
        ),
        'name'
      );
    },
    guidesToShow() {
      let list = this.guides;
      if (this.productId) {
        list = list.filter((x) => x.coreProduct.id === this.productId);
      }
      return list;
    },
    ...mapGetters({ guides: 'guides/list' })
  },

  async mounted() {
    if (this.$route.query.productId) {
      this.productId = this.$route.query.productId;
    }
    this.loadData();
  },

  methods: {
    loadData() {
      this.loading = true;
      this.$store
        .dispatch('guides/getList')
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    add() {
      this.$bus.$emit(this.$enums.EVENT_BUS_EVENTS.EDIT_GUIDE_SHOW, {});
    },
    rowClick(item) {
      this.$bus.$emit(this.$enums.EVENT_BUS_EVENTS.EDIT_GUIDE_SHOW, {
        id: item.id
      });
    }
  }
};
</script>
